import { render, staticRenderFns } from "./KDatePicker.vue?vue&type=template&id=5d4f184c&"
import script from "./KDatePicker.vue?vue&type=script&lang=js&"
export * from "./KDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports